import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FileExtensionPipe } from '../../pipes/file-extension.pipe'
import { AppendFileDomainPipe } from '../../pipes/append-file-domain.pipe'
import { NgClass } from '@angular/common'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { IsImagePipe } from '../../pipes/is-image.pipe'
import { UploadInputComponent } from '../upload-input/upload-input.component'
import { BasicInputComponent } from '@app/v2/shared/components/inputs/basic-input/basic-input.component'

@Component({
  selector: 'app-uploaded-file',
  templateUrl: './uploaded-file.component.html',
  styleUrls: ['./uploaded-file.component.scss'],
  standalone: true,
  imports: [FileExtensionPipe, AppendFileDomainPipe, NgClass, ReactiveFormsModule, BasicInputComponent, IsImagePipe]
})
export class UploadedFileComponent {
  public isImage!: boolean
  public fileNameControl: FormControl = new FormControl('')
  public isEditingFileName: boolean = false

  @Input() fileObject!: FormGroup
  @Input() canEditFileName!: boolean
  @Input() displayFilename!: boolean
  @Input() useImageCropper!: boolean

  @Output() cropImage: EventEmitter<void> = new EventEmitter<void>()
  @Output() deleteFile: EventEmitter<void> = new EventEmitter<void>()
  @Output() nameChanged: EventEmitter<void> = new EventEmitter<void>()

  /**
   * @description Handle editing file name & toggle its view
   */
  public toggleEditingName(): void {
    if (!this.canEditFileName) return
    this.fileNameControl = new FormControl(!this.isEditingFileName ? this.fileObject.value.name : '')
    this.isEditingFileName = !this.isEditingFileName
  }

  /**
   * @description apply changes on file name
   */
  public confirmFileNameChange(): void {
    if (this.fileNameControl.value && this.fileNameControl.value !== this.fileObject.get('name')?.value) {
      this.fileObject.get('name')?.setValue(this.fileNameControl.value)
      this.nameChanged.emit()
    }
    this.toggleEditingName()
  }
}
